module.exports = __webpack_public_path__ + "static/media/img-6.fedd767d.jpg";